import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const CompanyIntro = () => {
  const { t } = useLanguage();
  
  const companyIntroContent = [
    {
      titleKey: 'companyIntro1Title',
      contentKey: 'companyIntro1Content'
    },
    {
      titleKey: 'companyIntro2Title',
      contentKey: 'companyIntro2Content'
    },
    {
      titleKey: 'companyIntro3Title',
      contentKey: 'companyIntro3Content'
    }
  ];
  
  return (
    <section className="bg-[#0b004c] py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {companyIntroContent.map((column, index) => (
            <div key={index} className="text-white">
              <h3 className="font-montserrat-bold text-lg md:text-xl mb-4">
                {t(column.titleKey)}
              </h3>
              <p className="font-montserrat text-sm md:text-base leading-relaxed text-white/90 text-justify">
                {t(column.contentKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyIntro;
